import ConfirmationDlg from "../ConfirmationDlg";
import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useDashboardContext } from "../../contexts/NewDashboardContext";

function ModalAnnauncement({ openModal, setOpenModal, onSuccess, onCancel }) {
  const { relocateModal, updateRelocateModal } = useDashboardContext();
  const [open, setOpen] = React.useState(false);
  const [textValue, setTextValue] = React.useState("");
  const [quantity, setQuantity] = React.useState(1);
  const [relocateFrom, setRelocateFrom] = React.useState("");
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
    onCancel();
  };
  const submitHandler = async () => {
    if (relocateFrom === "" || quantity === "") {
      toast.error("Please input the field");
      return;
    }
    onSuccess(textValue);
    setOpenModal(false);
    setTextValue("");
    setOpen(false);
  };
  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  const handleChangeValue = (e) => {
    setQuantity(e.target.value);
  };

  const relocate = () => {
    updateRelocateModal(true);
    setOpen(false);
  };
  return (
    <ConfirmationDlg
      open={open}
      btnCancelText="Cancel"
      btnSubmitText={"Ok"}
      onSubmit={handleClose}
      hideCancelBtn={true}
      onClose={handleClose}
    >
      <div className="my-2">
        <div className="alert alert-primary">
          <div className="d-flex">
            <div style={{ paddingRight: "10px" }}>
              <i
                style={{ fontSize: "30px" }}
                className="bi bi-info-circle-fill"
              ></i>
            </div>
            <div>
              It is important to know that it is not recommended to change the
              default sensor installation. If you want to relocate any sensors,
              please inform Groundup.ai team.
            </div>
          </div>
          <hr />
          <div>
            Click the button below to inform your request and we will get back
            to you shortly.
          </div>
          <button className="btn btn-outline-theme mt-1" onClick={relocate}>
            Relocate
          </button>
        </div>
        <div className="alert alert-info">
          You can access the relocate request button again from Machine List
          Page
        </div>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalAnnauncement;
